import React from "react";
import {useNavigate} from "react-router-dom";
import {Loader} from "../../components/loading/Loader";
import EventPageDesktop from "./eventPageDesktop/EventPageDesktop";
import EventPageMobile from "./eventPageMobile/EventPageMobile";

import {useGetEvent} from "../../services/api/event/getEvent/useGetEvent";

export default function EventPageComponent() {
  const {data: eventData, isLoading} = useGetEvent();
  const navigate = useNavigate();

  if (isLoading || !eventData) {
    return <Loader type="color" />;
  }

  const {event, tickets} = eventData;
  const {
    title,
    description,
    image,
    date,
    venue,
    address,
    city,
    province,
    agendaLink,
  } = event;
  const {refundPolicy, transferPolicy, price, quantity} = tickets[1];

  const onContinue = () => {
    navigate(`/event/${event.id}/order-form`);
  };

  const eventProps = {
    title,
    description,
    image,
    date,
    venue,
    address,
    city,
    province,
    agendaLink,
    refundPolicy,
    transferPolicy,
    price,
    quantity,
    onContinue,
  };

  if (window.innerWidth < 768) {
    return <EventPageMobile {...eventProps} />;
  }

  return <EventPageDesktop {...eventProps} />;
}
